import jQuery from 'jquery';

jQuery(function($) {
  /* Отображение дополнительных полей после заполнения селектов  */
  let $calculate = $('.form--calculate');

  $calculate.each(function() {
    let $form = $(this);
    let $selects = $form.find('.form__select');
    let $rowHidden = $form.find('.form__row.d-none');

    $selects.on('change', function() {
      let $selectsFilled = $selects.filter(function() {
        return $(this).val() !== null;
      });

      if ($selectsFilled.length === $selects.length) {
        $rowHidden.removeClass('d-none');
      }
    });
  });

  /* Отображение дополнительных полей при выборе пользовательского значения в селекте  */
  let $formFields = $('.form__field');

  $formFields.filter('select[data-additional-field-selector]').on('change', function() {
    let $originalField = $(this);

    let $additionalField = $($originalField.data('additionalFieldSelector'));
    let $additionalFieldRow = $additionalField.closest('.form__row--additional');

    $additionalField.prop('disabled', $originalField.val() !== 'custom');
    $additionalFieldRow.toggleClass('d-block', $originalField.val() === 'custom');
  });

  $('.form__field--phone').each(function() {
    const $phone = $(this);

    $phone.unmask();

    const options = {
      onKeyPress: function(cep, e, field, options) {
        const masks = ['+0 (000) 000-00-00', '+000000000000000'];
        const mask = cep.charAt(1) === '7' ? masks[0] : masks[1];

        $phone.mask(mask, options);
      },
    };

    $phone.mask('+0 (000) 000-00-00', options);

    $phone.on('keydown', function(event) {
      const key = event.key;

      if (key >= 0 && key <= 9) {
        if (key === '8' && $phone.val().length === 0) {
          $phone.val('+7');
          return false;
        }
      }
    });

    $phone.on('paste', function(event) {
      event.preventDefault();

      const copiedText = event.originalEvent.clipboardData.getData('text');
      let clearedText = copiedText.replace(/[^+0-9]/g, '');

      if (clearedText.length === 10) {
        clearedText = `+7${ clearedText }`;
      } else if (clearedText.charAt(0) === '8') {
        clearedText = `+7${ clearedText.slice(1) }`;
      }

      $phone.val($phone.masked(clearedText));
    });
  });
});
